// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:767px){.bucketCreatorWrapper[data-v-65cefb4c]{display:flex;flex-direction:column}.headTitle[data-v-65cefb4c]{font-size:var(--font-size-title)}}", ""]);
// Exports
module.exports = exports;
